import React, {useEffect, useState} from "react";
import { useNavigate , useLocation} from "react-router";


import LocalStorageDataStorer from "../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../dataAccessLayer/localStorage/LocalStorageKey";
import QuestionnaireManager from "../../businessLayer/managers/QuestionnaireManager";
import HttpStatusCode from "../../utils/httpProtocol/HttpStatusCode";
import DownloadReportButton from "./buttons/DownloadReportButton";
import AccessControlInspector from "../../serviceLayer/authorization/AccessControlInspector";
import RoleBasedAccessControlOrigin from "../../utils/stringLiterals/RoleBasedAccessControlOrigin";

export default function QuestionnaireSection(){

    const navigate = useNavigate();
    const location = useLocation();
    const [questionnaireReportPending, setQuestionnaireReportPending] = useState(false);
    const [questionnaireReportComplete, setQuestionnaireReportComplete] = useState(false);

    const [canTakeAssessment, setCanTakeAssessment] = useState(false);
    const [canViewQuestionnaireReport, setCanViewQuestionnaireReport] = useState(false);
    const [canDownload, setCanDownload] = useState(false);

    useEffect(()=>{
        async function loadResources() { 
            const allResources = await AccessControlInspector.getAllresourcesFromAPIAsync(RoleBasedAccessControlOrigin.customer);
            //console.log("allResources", allResources);
            processUserPermissions(allResources._main.name, allResources._main.actions);

        }
        loadResources();
        //Here we call the Questionnaire report Information from the API.
        const questionnaireReport = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.allCharacterTypesDataPoints);
        if(questionnaireReport){
            setQuestionnaireReportPending(false);
            setQuestionnaireReportComplete(true);
        }else{
            QuestionnaireManager.getResponseReport(getResponseReportCallback);
        }
    
    }, []);
    function processUserPermissions(resourceName , actions){
        //console.log("processUserPermissions-resourceName" , resourceName);
        //console.log("processUserPermissions-actions", actions);
        const userCanTakeAssessment = AccessControlInspector.userHasPermission(resourceName, actions._take_quiz);
        const userCanViewQuestionnaireReport = AccessControlInspector.userHasPermission(resourceName, actions._view_questionnaire_report);
        const userCanDownload = AccessControlInspector.userHasPermission(resourceName, actions._download_questionnaire_report);

        setCanTakeAssessment(userCanTakeAssessment);
        setCanViewQuestionnaireReport(userCanViewQuestionnaireReport);
        setCanDownload(userCanDownload);
    }
    function getResponseReportCallback(httpResponse){
        //console.log("getResponseReportCallback-httpResponse", httpResponse);        

        if(httpResponse.code === HttpStatusCode._200ok.code){
            setQuestionnaireReportPending(false);
            setQuestionnaireReportComplete(true);
        }else{
            setQuestionnaireReportPending(true);
            setQuestionnaireReportComplete(false);
        }       
    }
    

    function onTakeQuestionnaireButtonClickedEvent(event){
        //console.log("onTakeQuestionnaireButtonClickedEvent-event", event);
        event.preventDefault();
        navigate("/private/questionnaire", { state: { fromPage: location.pathname }});
    }

    function onViewReportButtonClickedEvent(event){
        //console.log("onViewReportButtonClickedEvent-event", event);
        event.preventDefault();
        navigate("/private/questionnaire/report", { state: { fromPage: location.pathname }});
    }


    return (<div className="flex-column-items-center container-lightblue position-rel">
        <span className="questionnaire-title position-rel mt-15"> Questionnaire </span>
        <span className="questionnaire-status-name position-rel mt-15"> Status </span>
        { questionnaireReportPending &&
            <div className="questionnaire-status-type-container">
                <h1 className="questionnaire-status-type position-rel mt-15 font-color-darkblue">Ready To Be Completed </h1>                
                <p className="font-color-darkblue"> <strong>Note: </strong>This assessment is based on Wilhelm Reich's character structure theory.
                    Results should be interpreted as tendencies rather than fixed categories. 
                    Professional consultation is recommended for deeper understanding.
                </p>
                <h3 className="questionnaire-status-type mt-30 font-color-darkblue">Instructions</h3>  
                <p className="font-color-darkblue mb-15">For each question, select the option that <strong>BEST describes you.</strong>
                You must choose one answer that most closely matches your experience or tendency.
                </p>
            </div>
        }
        {questionnaireReportComplete &&
            <div className="questionnaire-status-type-container">
                 <h1 className="questionnaire-status-type position-rel mt-30 mb-30 font-color-darkblue"> Completed </h1>  
            </div>
        }
        <div className="flex-row"> 
            {questionnaireReportComplete &&  
            <div className="mt-30 flex-row">  
                {canViewQuestionnaireReport && <>       
                    <button className="btn-element btn-h45 btn-w135 font-s12 position-rel mt-30"
                        onClick={onViewReportButtonClickedEvent} > View Report 
                    </button>
                </>}
                { canDownload &&
                    <DownloadReportButton targetRoute="/private/questionnaire/report" returnRoute="/private/main" />
                }
            </div>}
            {questionnaireReportPending && 
            <>
                { canTakeAssessment && <> 
                    <button className="btn-element btn-h45 btn-w115 font-s12 position-rel mt-30 "
                        onClick={onTakeQuestionnaireButtonClickedEvent} > Take the Assessment 
                    </button>
                </>}
            </>}
        </div>
    </div>) 
}